import { Directive } from '@angular/core';
import { Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appDropdown]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: ValidateDropdownDirective, multi: true },
    ]
})

export class ValidateDropdownDirective implements Validator {

    validate(control: FormControl) {
        const value = control.value;
        return !value || value === '0' ? Object.assign({}, { required: true }) : null;
    }
}
